module.exports = "/assets/data/8c984e276cd362f9cfb5197bd4ccffae-BT92.data.json";